import React from 'react';
import { FinancialConnectionsAccountAccountNumbersUpdatedEventFragment } from '#types';
import { gql } from '@apollo/client';
import { Typography } from '@mui/material';

export const financialConnectionsAccountAccountNumbersUpdatedEventFragment = gql`
	fragment financialConnectionsAccountAccountNumbersUpdatedEvent on Event {
		id
		category
		metadata
	}
`;

export const getFinancialConnectionsAccountAccountNumbersUpdatedProps =
	( eventProps: {
		event: FinancialConnectionsAccountAccountNumbersUpdatedEventFragment;
		message: React.JSX.Element;
		links: {
			type: string;
			text: string;
			link: any;
			onClick?: ( () => any ) | null;
		}[];
		icon: string;
		className: string;
	} ) => {
		if ( !eventProps.event.metadata ) {
			throw new Error( `Event ID ${ eventProps.event.id } missing required data` );
		}

		const { last4 } = eventProps.event.metadata;

		if ( !last4 ) {
			throw new Error( `Event ID ${ eventProps.event.id } missing required data` );
		}

		return {
			...eventProps,
			icon: 'money-bank',
			message: (
				<Typography>
					Your payment method ending in { last4 } was deactivated by your bank. If
					you had any scheduled payments associated with this payment method,
					they have been deactivated.
				</Typography>
			),
		};
	};
